import cn from 'classnames';
import React from 'react';

import s from './ProductWrapper.module.scss';

interface Props {
  isSelected?: boolean;
  isCurrentUserPlan?: boolean;
  children: JSX.Element;
  className?: string;
}

export default function ProductWrapper({
  isSelected,
  children,
  isCurrentUserPlan,
  className,
}: Props): JSX.Element {
  return (
    <div
      className={cn(
        s.wrapper,
        {
          [s.selected]: isSelected,
          [s.current]: isCurrentUserPlan,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}
